export const BANNER = {
  imageAltText: 'Switch to Origin',
  image: {
    sha: '2c274b81c0fa9c30a35b465d3d55d554e4370bbb',
  },
  showDisclaimer: 'false',
  graphicColour: 'orange',
  textIsRich: 'true',
  graphicShape: 'dash',
  bannerStyle: 'orange',
  disclaimerText: '',
  imageContentBoxAlign: 'left',
  headline: 'Switch to Origin in as little as 3&nbsp;minutes',

  ctas: [
    {
      ctaType: 'primary',
      ctaText: 'See internet plans',
      ctaLink: '/internet.html',
      ctaTarget: '_self',
    },
  ],
  bylineHtml: '',
  postcodeEntry: 'true',
};
export const TOP_CARD = {
  items: [
    {
      imageSHA: '3db2df931e13f80e97b892984e5f539107926cb7',
      headline: 'Earn points for Paypal cash & gift cards',
      bylineHtml:
        'Over <b>$1 million in Spike points</b> have been awarded to Origin customers for taking part in Spike, our exciting new energy-saving program.',
      buttonLabel: 'Learn more about Spike',
      href: '/spike/',
      logoSHA: '900943353f00a0f65db40baf7369c62515173e37',
    },
    {
      imageSHA: '57f15769f000ed79f55df36036f3ebf2048dd5d2',
      headline: 'Electricity and natural gas plans',
      bylineHtml:
        'Choose from a range of plan benefits including fixed rates. With no lock-in contract or exit fees on home energy plans, you can change your mind, anytime.',
      buttonLabel: 'See energy plans',
      href: '/electricity-gas/plans.html',
      logoSHA: 'ccf35e28ed513ff455cacd73a3d53514c2c4c3ab',
    },
    {
      imageSHA: 'f9e0f36f288f77cdcc142f53b53e2807cb4358ba',
      headline: 'Reduce your bills with solar',
      bylineHtml:
        'Solar systems are more accessible, affordable and easier to install than ever before. We’ll help tailor the right solution for you.',
      buttonLabel: 'Request a quote',
      href: '/solar/quote',
      logoSHA: 'dba7965517141910c0d740afa2d7946598271f2a',
    },
    {
      imageSHA: '691f65f4a10f733e3e7e2d667650b1d9ed7f2adc',
      headline: 'Save up to $120 per year on your&nbsp;internet',
      bylineHtml:
        'That’s $10 a month off your internet when you have an energy plan with Origin. Choose your speed – get unlimited data!',
      buttonLabel: 'See internet plans',
      href: '/internet.html',
      logoSHA: 'c3ea4423301944e93d1c8c1af42ed550e7c956ca',
    },
  ],
};
export const HELP_SUPPORT = {
  mainHeading: 'We’re here for you',
  items: [
    {
      buttonUrl: '/help-support',
      bylineHtml:
        'Residential customers – search help topics including direct debit, energy usage, rates and estimated meter reads.',
      headline: 'Help and support',
      iconSvg:
        '<svg width="48" height="48" viewBox="0 0 24 24">    <path d="M0 0h24v24H0z" fill="none"/> <path d="M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 16h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 11.9 13 12.5 13 14h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/></svg>',
      target: '',
    },
    {
      buttonUrl: '/for-home/electricity-and-gas/info/emergencies.html',
      bylineHtml:
        'In the event of an outage, our online tool will help you look up your energy supplier or gas provider.',
      headline: 'Outages',
      iconSvg:
        '<svg width="48" height="48" viewBox="0 0 48 48"><path d="M2 42h44L24 4 2 42zm24-6h-4v-4h4v4zm0-8h-4v-8h4v8z"/></svg>',
      target: '',
    },
    {
      buttonUrl: '/contact.html',
      bylineHtml:
        'We’re here for you via Message, email or phone: Mon–Fri, 7 am–9 pm, Sat–Sun, 8 am–5&nbsp;pm (AEST).',
      headline: 'Customer service',
      iconSvg:
        '<svg width="48" height="48" viewBox="0 0 24 24"> <path d="M0 0h24v24H0z" fill="none"/><path d="M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"/></svg>',
      target: '',
    },
  ],
};
export const DIGITAL_ADOPTION = {
  androidLink: 'https://m.origin.com.au/fo2UErMINgb',
  appleLink: 'https://m.origin.com.au/fo2UErMINgb',
  headline: 'Energy made easier',
  byline:
    'Access energy insights, bill history, electricity usage and more with your free and easy-to-use Origin app.',
  imageSHA: '425eaaba80b6cae7058fe554922cb9f0ccd12d8a',
};
export const QUICK_LINKS = {
  redesign: true,
  items: [
    {
      headline: 'Energy plans',
      buttonUrl: '/electricity-gas/plans.html',
      iconSvg:
        '<svg width="48" height="48" viewBox="0 0 24 24">\n<path d="M3,18.75a.77.77,0,0,0,.75.75h3a.77.77,0,0,0,.75-.75V18H3ZM5.25,4.5a5.25,5.25,0,0,0-3,9.56V16a.81.81,0,0,0,.75.8H7.5a.81.81,0,0,0,.75-.8V14.06a5.25,5.25,0,0,0-3-9.56Zm2,8.17-.6.42V15H3.85V13.09l-.6-.43a3.49,3.49,0,1,1,4.87-.87,3.59,3.59,0,0,1-.87.87Z" /><path d="M21.57,9.6,17.39,5.5,13.22,9.6a5.74,5.74,0,0,0,0,8.21,6,6,0,0,0,4.08,1.69h.14a5.78,5.78,0,0,0,4.11-9.9Zm-4.78,8a2.7,2.7,0,0,1,0-2.94l.6-.77.54.77a2.74,2.74,0,0,1,0,2.94,1.33,1.33,0,0,1-.29.29h-.57A1.28,1.28,0,0,1,16.79,17.6Zm2.19,0c1.21-1.56.61-2.56-.06-3.77l-1.53-2.28L15.8,13.8c-.66,1.2-1.12,2.1-.08,3.74a4.07,4.07,0,0,1-2.48-3.62V13.8a4.21,4.21,0,0,1,1.33-3l2.82-3,2.83,3a4.13,4.13,0,0,1,1.32,2.94v.12A4,4,0,0,1,19,17.57Z" />\n</svg>',
    },
    {
      headline: 'Move house',
      buttonUrl: '/moving.html',
      iconSvg:
        '<svg width="48" height="48" viewBox="0 0 24 24">\n<path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zm-.5 1.5l1.96 2.5H17V9.5h2.5zM6 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2.22-3c-.55-.61-1.33-1-2.22-1s-1.67.39-2.22 1H3V6h12v9H8.22zM18 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z" />\n</svg>\n',
    },
    {
      headline: 'Solar',
      buttonUrl: '/solar.html',
      iconSvg:
        '<svg width="48" height="48" viewBox="0 0 24 24">\n<path d="M6.76 4.84l-1.8-1.79-1.41 1.41 1.79 1.79zM1 10.5h3v2H1zM11 .55h2V3.5h-2zm8.04 2.495l1.408 1.407-1.79 1.79-1.407-1.408zm-1.8 15.115l1.79 1.8 1.41-1.41-1.8-1.79zM20 10.5h3v2h-3zm-8-5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm-1 4h2v2.95h-2zm-7.45-.96l1.41 1.41 1.79-1.8-1.41-1.41z" />\n</svg>',
    },
    {
      headline: 'LPG',
      buttonUrl: '/lpg.html',
      iconSvg:
        '<svg width="48" height="48" version="1.1" fill="currentColor" color="#ffb432"  viewBox="0 0 48 48">\n\t<path fill="none" d="M0,0h48v48H0V0z"/>\n\t<path fill-rule="evenodd" clip-rule="evenodd" d="M16,38h16v8H16V38z"/>\n\t<path fill="currentColor" d="M32,42H16c-2.3,0-4-1.7-4-4V16c0-3.3,2.7-6,6-6h12c3.3,0,6,2.7,6,6v22C36,40.3,34.3,42,32,42z M16,38\n\t\th16V16c0-1.1-0.9-2-2-2H18c-1.1,0-2,0.9-2,2V38z"/>\n\t<g>\n\t\t<path fill-rule="evenodd" clip-rule="evenodd" d="M18,6h12v4H18V6z M24,6c1.2,0,2,0.8,2,2v2h-4V8 C22,6.8,22.8,6,24,6z M16,2h16v4H16V2z"/>\n\t</g>\n</svg>',
    },
    {
      headline: 'Internet',
      buttonUrl: '/internet.html',
      iconSvg:
        '<svg width="48" height="48" viewBox="0 0 48 48">\n<path d="M0 0h48v48H0z" fill="none"></path>\n<path d="M3,17.6911364 L6.81818182,21.5093182 C16.3063636,12.0211364 31.6936364,12.0211364 41.1818182,21.5093182 L45,17.6911364 C33.4118182,6.10295455 14.6072727,6.10295455 3,17.6911364 Z M18.2727273,32.9638636 L24,38.6911364 L29.7272727,32.9638636 C26.5772727,29.7947727 21.4418182,29.7947727 18.2727273,32.9638636 Z M10.6363636,25.3275 L14.4545455,29.1456818 C19.7236364,23.8765909 28.2763636,23.8765909 33.5454545,29.1456818 L37.3636364,25.3275 C29.9945455,17.9584091 18.0245455,17.9584091 10.6363636,25.3275 Z"/>\n</svg>\n',
    },
    {
      headline: 'My Account',
      buttonUrl: '/auth/#/login/start',
      iconSvg:
        '<svg width="48" height="48" viewBox="0 0 24 24">\n<path d="M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z" />\n</svg>\n',
    },
  ],
};

export const TOP_LIGHT_CARD = {
  headline: 'Make the hassle-free switch for great rates on your electricity, gas & internet',
  items: [
    {
      imageSHA: '258dcd7158cbcf471fb79ce28b9b5603b4cbf16d',
      headline: 'Great rates, no lock-in contracts',
      byline:
        // tslint:disable-next-line:max-line-length
        'Easy-to-understand pricing and a great range of home energy plans. All with no lock-in contracts or exit fees.',
      buttonLabel: 'Compare energy plans',
      href: '/electricity-gas/plans.html',
    },
    {
      imageSHA: 'ed90a03f59708465da48fea90aec84dcf7b2f5e6',
      headline: 'Changing electricity retailers',
      byline:
        'We’ve made switching electricity providers fast and easy. Signing up online takes minutes, and we’ll let your old provider know.',
      buttonLabel: 'Switch to Origin',
      href: '/switch.html',
    },

    {
      imageSHA: 'b4ef9021ca078134efdf7af0960686b4deee6809',
      headline: 'Accredited green',
      byline:
        'Know you can make a difference with our accredited GreenPower and certified Green Gas.',
      buttonLabel: 'More on sustainability',
      href: '/about/sustainability.html',
    },
  ],
  color: '#F8F8F8',
};
